import React from 'react';
import { Server } from 'lucide-react';
import ServiceHeader from '../../components/services/ServiceHeader';
import ServiceFeatureCard from '../../components/ui/ServiceFeatureCard';
import { colors } from '../../styles/theme';
import ServiceSteps from '../../components/services/sections/ServiceSteps';

const features = [
  {
    iconName: "Cpu",
    title: "Performance",
    description: "CPU dédiés et RAM garantie"
  },
  {
    iconName: "HardDrive",
    title: "Stockage NVMe",
    description: "Disques ultra-rapides en RAID"
  },
  {
    iconName: "Network",
    title: "Réseau 10 Gbps Français",
    description: "Bande passante garantie"
  },
  {
    iconName: "Shield",
    title: "Sécurité",
    description: "Protection DDoS incluse"
  },
  {
    iconName: "Terminal",
    title: "Accès Root",
    description: "Contrôle total du serveur"
  },
  {
    iconName: "BarChart",
    title: "Monitoring",
    description: "Supervision en temps réel"
  }
];

const plans = [
  {
    name: "VPS-DEV",
    specs: [
      "1 vCPU",
      "1 Go RAM",
      "4 Go SSD NVMe",
      "1 IPv4 dédiée",
      "Trafic illimité",
      "Protection DDoS"
    ]
  },
  {
    name: "VPS-PRO",
    specs: [
      "4 vCPU",
      "8 Go RAM",
      "50 Go SSD NVMe",
      "1 IPv4 dédiée",
      "Trafic illimité",
      "Protection DDoS+"
    ]
  }
];

const steps = [
  {
    title: "Inscrivez-vous sur FRANCE STUDENT",
    description: "Créez votre compte étudiant en quelques clics"
  },
  {
    title: "Vérifiez votre statut étudiant",
    description: "Téléchargez votre carte étudiante ou certificat de scolarité"
  },
  {
    title: "Commandez votre VPS",
    description: "Choisissez votre offre et déployez votre serveur"
  }
];

const VPSPage = () => {
  const handleOrder = () => {
    window.location.href = 'https://my.francestudent.org/store/vps';
  };
  return (
    <div>
      <ServiceHeader
        title="Serveur Privé Virtuel"
        description="Des VPS haute performance pour vos projets, avec un contrôle total sur votre environnement."
        icon={<Server className="w-8 h-8 text-white" />}
        color={colors.accent2}
        imageUrl="https://images.unsplash.com/photo-1597852074816-d933c7d2b988?auto=format&fit=crop&q=80"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Caractéristiques */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <ServiceFeatureCard
              key={index}
              iconName={feature.iconName}
              title={feature.title}
              description={feature.description}
              color={colors.accent2}
            />
          ))}
        </div>

        {/* Plans VPS */}
        <section className="mt-16">
          <h2 className="text-2xl font-bold mb-8">Nos Plans VPS</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {plans.map((plan, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-lg p-8">
                <h3 
                  className="text-xl font-bold mb-4"
                  style={{ color: colors.accent2 }}
                >
                  {plan.name}
                </h3>
                <ul className="space-y-3 text-gray-600">
                  {plan.specs.map((spec, i) => (
                    <li key={i} className="flex items-center">
                      <span 
                        className="w-2 h-2 rounded-full mr-2"
                        style={{ backgroundColor: colors.accent2 }}
                      />
                      {spec}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>
        <div class="pt-11">
          <ServiceSteps
                title="Comment en Bénéficier"
                steps={steps}
                color={colors.accent2}
                ctaText="Commander mon VPS"
                onCtaClick={handleOrder}
          />
        </div>
      </div>
    </div>
  );
};

export default VPSPage;